module.exports = __webpack_public_path__ + "img/skippable.03382b66.svg";